import { createSlice } from "@reduxjs/toolkit";

const int010_post_technical_ticket = createSlice({
  name: 'int010_post_technical_ticket',
  initialState: {
    value: {
      Descricao_Problema: "",
      Endereco: "",
      Integracao: "",
      Razao_Social: "",
      Numero_Serie: "",
      Titulo_Problema: "",
      Contrato: "",
      Celular: "",
      Email: "",
      Nome: "",
      Numero_Filial: "",
      Nome_Equipamento: ""
    }
  },
  reducers: {
    setPayload(state, { payload }) {
      state.value[Object.keys(payload)] =
        payload[Object.keys(payload)];
    },
  }
})

export const {setPayload} = int010_post_technical_ticket.actions
export default int010_post_technical_ticket.reducer